import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { Button, Drawer, Image } from 'antd';
import { styled } from '@xstyled/styled-components';
import { MenuSideBar } from '../menu-sidebar';
import { AppLogo } from '../logo.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledDrawer = styled(Drawer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-drawer-body {\n    display: flex;\n    flex-flow: column;\n    padding: 0;\n    ul:first-child {\n      margin-bottom: auto;\n      .ant-card {\n        border: none;\n      }\n    }\n  }\n"])));
var StyledHamburgerButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 0px;\n  background-color: ", ";\n  .ant-image {\n    img {\n      filter: invert(12%) sepia(83%) saturate(5841%) hue-rotate(244deg) brightness(87%)\n        contrast(153%);\n    }\n  }\n"])), function (props) {
  return props.theme.colors.blue1;
});
export var AppPopupSidebarComponent = function AppPopupSidebarComponent(props) {
  var logoSrc = props.logoSrc,
      menuItems = props.menuItems,
      translation = props.translation,
      selectedKeys = props.selectedKeys,
      bottomMenuItems = props.bottomMenuItems,
      isLoadingUserInfo = props.isLoadingUserInfo,
      userInfo = props.userInfo,
      navigateToPath = props.navigateToPath,
      urlNavigateAccountSettingPage = props.urlNavigateAccountSettingPage,
      hamburgerHeaderSrc = props.hamburgerHeaderSrc,
      onClose = props.onClose,
      open = props.open;

  var getFirstCharactersInFullName = function getFirstCharactersInFullName(fullName) {
    var allNames = fullName.trim().split(' ');
    var initials = allNames.reduce(function (acc, curr, index) {
      if (index === 0 || index === allNames.length - 1) {
        acc = "".concat(acc).concat(curr.charAt(0).toUpperCase());
      }

      return acc;
    }, '');
    return initials;
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledDrawer, {
      title: /*#__PURE__*/_jsx(AppLogo, {
        srcImg: logoSrc,
        disabled: true
      }),
      placement: "left",
      closeIcon: /*#__PURE__*/_jsx(StyledHamburgerButton, {
        type: "link",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(Image, {
          src: hamburgerHeaderSrc,
          preview: false,
          alt: "logo",
          width: 40,
          height: 40
        })
      }),
      width: "70%",
      onClose: onClose,
      open: open,
      children: /*#__PURE__*/_jsx(MenuSideBar, {
        menuItems: menuItems,
        translation: translation,
        selectedKeys: selectedKeys,
        bottomMenuItems: bottomMenuItems,
        isLoadingUserInfo: isLoadingUserInfo,
        firstLetterOfUsername: getFirstCharactersInFullName(userInfo),
        urlNavigateAccountSettingPage: urlNavigateAccountSettingPage,
        formattedUsername: userInfo,
        navigateToPath: navigateToPath
      })
    })
  });
};